import { getRequest } from '@/core';
import { trips } from '@/requests';

export default async function getTripByIdRequest(id) {
	let url = trips.getByIdPath(id);
	let response = await getRequest(url);
	return response;
}